
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-forti-fi-background flex flex-col items-center justify-center p-4 text-center">
      <h1 className="text-6xl md:text-7xl font-serif text-forti-fi mb-6">404</h1>
      <h2 className="text-2xl md:text-3xl text-forti-fi-charcoal mb-6">Page Not Found</h2>
      <p className="text-lg text-forti-fi-charcoal max-w-md mb-8">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>
      <Button asChild variant="gradient" className="text-white">
        <Link to="/">Return to Home</Link>
      </Button>
    </div>
  );
};

export default NotFound;
